import "./styles/Global.scss";
import Routes from "./pages/Routes";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./services/queryClient";
import { PolicemanContextProvider } from "contexts/policemanContext";
import { NotificationProvider } from "contexts/notificationContext";
import { AuthProvider } from "contexts/authContext";
import { PolicemanRegisterProvider } from "contexts/register/PolicemanContext";
import { UserRegisterProvider } from "contexts/register/UserContext";
import { ClientContextProvider } from "contexts/clientContext";
import { ClientRegisterProvider } from "contexts/register/ClientContext";
import { OccurrenceRegisterProvider } from "contexts/register/OccurrenceContext";
import { ProviderRegisterProvider } from "contexts/register/ProviderContext";
import { ServiceRegisterProvider } from "contexts/register/ServiceContext";
import { SubClientRegisterProvider } from "contexts/register/SubClientContext";
import { LocaleRegisterProvider } from "contexts/register/LocaleContext";
import { ReportProvider } from "contexts/ReportContext";
import { MonkUiProvider } from "monk_ui";

import { Libraries, LoadScript } from "@react-google-maps/api";
import { MaintenanceRegisterProvider } from "contexts/register/Maintenance";

export const LOADSCRIPT_KEY = "AIzaSyCyYIwYpE42g7zN-nVRrPKkAwRseyccpaM";

const LOADSCRIPT_LIBRARIES: Libraries = ['places'];

function App() {
  return (
    <div className="App">
      <LoadScript
        googleMapsApiKey={LOADSCRIPT_KEY}
        libraries={LOADSCRIPT_LIBRARIES as any}
      >
        <MonkUiProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <SubClientRegisterProvider>
                <ReportProvider>
                  <UserRegisterProvider>
                    <OccurrenceRegisterProvider>
                      <PolicemanContextProvider>
                        <PolicemanRegisterProvider>
                          <MaintenanceRegisterProvider>
                            <ClientContextProvider>
                              <ClientRegisterProvider>
                                <NotificationProvider>
                                  <ServiceRegisterProvider>
                                    <ProviderRegisterProvider>
                                      <LocaleRegisterProvider>
                                        <Router>
                                          <Routes />
                                        </Router>
                                      </LocaleRegisterProvider>
                                    </ProviderRegisterProvider>
                                  </ServiceRegisterProvider>
                                </NotificationProvider>
                              </ClientRegisterProvider>
                            </ClientContextProvider>
                          </MaintenanceRegisterProvider>
                        </PolicemanRegisterProvider>
                      </PolicemanContextProvider>
                    </OccurrenceRegisterProvider>
                  </UserRegisterProvider>
                </ReportProvider>
              </SubClientRegisterProvider>
            </AuthProvider>
          </QueryClientProvider>
        </MonkUiProvider>
      </LoadScript>
    </div>
  );
}

export default App;
